import { useContent } from '@/content';
import { Editable } from '@/content/design';

export default function MesoporationSection() {
  const c = useContent();
  return (
    <section id="mesoporation" className="py-20 md:py-28 bg-white relative">
      {/* Background accents – wrapped for overflow control */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-champagne-50 blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-blush-50 blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10">
        {/* Highlight badge */}
        <div className="flex justify-center mb-10 animate-on-scroll">
          <div className="inline-flex items-center gap-2 bg-champagne-500 text-white text-xs tracking-widest uppercase font-medium px-5 py-2 rounded-full shadow-md">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-xs"></i>
            </div>
            {c.mesoporation.badge}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Image side */}
          <div className="animate-on-scroll-left lg:sticky lg:top-28">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/62e59b4a12706970a459027b4a407756/ae814a29b6894d5fa44727d01ca52ec0.jpeg"
                alt="Mesoporationsgerät im Kosmetikstudio Gesichtszauber"
                title="Mesoporation Gerät – Exklusiv im Kosmetikstudio Gesichtszauber Wertingen"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>
            <div className="mt-4 flex items-center gap-2 text-gray-400 text-xs">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-camera-line"></i>
              </div>
              {c.mesoporation.caption}
            </div>
          </div>

          {/* Text side */}
          <div>
            <div className="animate-on-scroll-right">
              <Editable as="p" id="mesoporation.eyebrow" label="Mesoporation – Kleine Überschrift" className="text-xs tracking-[0.3em] uppercase text-champagne-500 font-medium mb-3">
                {c.mesoporation.eyebrow}
              </Editable>
              <Editable as="h2" id="mesoporation.title" label="Mesoporation – Titel" className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-6 leading-tight">
                {c.mesoporation.title}
              </Editable>
            </div>

            <div className="space-y-4 text-gray-600 leading-relaxed">
              <Editable as="p" id="mesoporation.intro" label="Mesoporation – Einleitung" className="animate-on-scroll-right delay-100 font-medium text-gray-800 text-lg">
                {c.mesoporation.intro}
              </Editable>
              <Editable as="p" id="mesoporation.p1" label="Mesoporation – Absatz 1" className="animate-on-scroll-right delay-150">
                {c.mesoporation.p1}
              </Editable>
              <Editable as="p" id="mesoporation.p2" label="Mesoporation – Absatz 2" className="animate-on-scroll-right delay-200">
                {c.mesoporation.p2}
              </Editable>
              <Editable as="p" id="mesoporation.p3" label="Mesoporation – Absatz 3" className="animate-on-scroll-right delay-250 font-medium text-gray-800">
                {c.mesoporation.p3}
              </Editable>

              <div className="animate-on-scroll-right delay-300 bg-blush-50/50 rounded-xl p-5 md:p-6 border border-blush-100">
                <Editable as="p" id="mesoporation.resultsTitle" label="Mesoporation – Ergebnis-Überschrift" className="font-medium text-gray-800 text-sm mb-4">{c.mesoporation.resultsTitle}</Editable>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-2.5 text-sm text-gray-600">
                  {c.mesoporation.results.map((result, i) => (
                    <div key={i} className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-champagne-500 text-xs"></i>
                      </div>
                      {result}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}